import { render, staticRenderFns } from "./set-error.vue?vue&type=template&id=7bfc04ac&scoped=true"
import script from "./set-error.vue?vue&type=script&lang=js"
export * from "./set-error.vue?vue&type=script&lang=js"
import style0 from "./set-error.vue?vue&type=style&index=0&id=7bfc04ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfc04ac",
  null
  
)

export default component.exports